'use strict';

/*global Container */
function Translator(containerName) {
    this.containerName = containerName;
    this.container = null;
    
    this.init();
}

Translator.prototype = $.extend({}, {
    construtor: 'Translator', 
    
    //**************************************************************************    
    trans: function trans(string) {
        var _this = this;

        if (_this.container.has(string)) {
            return _this.container.get(string);
        }

        return string;
    },
    
    //**************************************************************************    
    init: function init() {
        var _this = this;

        _this.container = new Container();
        if (_this.containerName in window) {
            var array = window[_this.containerName];
            _this.container.loadFromArray(array);
        }
        return _this;
    } 
});
